import { AnimationTypography } from '@/components/shared/atoms';

interface MobileTitleProps {
  title: string;
  subTitle: string;
  pt?: number;
  pb?: number;
  pl?: number;
  isDark?: boolean;
}

const MobileTitle = ({ title, subTitle, pt = 40, pb = 80, pl = 20, isDark = false }: MobileTitleProps) => {
  return (
    <div className={`flex flex-col w-full mx-auto`} style={{ paddingLeft: `${pl}px`, paddingTop: `${pt}px`, paddingBottom: `${pb}px` }}>
      <AnimationTypography as="h1" type="fade-in-up" distance="16px" delay="200ms" className={`text-title2Medium ${isDark ? 'text-white' : 'text-coolNeutral-10'} pb-6`}>
        {title}
      </AnimationTypography>
      <AnimationTypography type="fade-in-up" distance="16px" delay="200ms" className={`text-body2Regular ${isDark ? 'text-white' : 'text-coolNeutral-10'}`}>
        {subTitle}
      </AnimationTypography>
    </div>
  );
};

export default MobileTitle;
